const PriceTag = () => {
  return <div className="inline-flex items-baseline gap-2">
        <span className="text-2xl text-muted-foreground line-through font-light">39,99€</span>
        <span className="text-5xl font-bold text-foreground drop-shadow-lg">19,99€</span>
        
      </div>;
};
export default PriceTag;